import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import axios from 'axios';
import config from './config';
const cache = new InMemoryCache();
let link = new createHttpLink({
  uri: config.serviceEndpoints.graphQl
});

class ClientToken {
  constructor() {
    this.token = null;
    this.authLink = null;
    this.apolloClient = null;
    this.documentRequest = null;
    this.entityDetailsRequest = null;
    this.authorizeRequest = axios.create({
      baseURL: config.serviceEndpoints.authorize
    });
  }
  setTokenClient = token => {
    if (!this.token && !this.apolloClient) {
      this.token = token;
      this.authLink = setContext((_, { headers }) => {
        return {
          headers: {
            ...headers,
            authorization: this.token ? `Bearer ${this.token}` : ''
          }
        };
      });

      link = this.authLink.concat(link);

      this.apolloClient = new ApolloClient({
        cache,
        link
      });

      this.documentRequest = axios.create({
        baseURL: config.serviceEndpoints.consent,
        headers: { authorization: `Bearer ${token}` }
      });

      this.entityDetailsRequest = axios.create({
        baseURL: config.serviceEndpoints.organizationUrl,
        headers: { authorization: `Bearer ${token}` }
      });
    }
  };
}

export let client = new ClientToken();
